// frontend/src/hooks/useNationalIdHandlers.js

import { isNationalIdInvalid } from '../utils/idValidators'

/**
 * Valida el número de cédula al perder el foco y, si procede,
 * consulta el padrón externo.
 *
 * @param {Event}    e                   Evento blur del <input>.
 * @param {Object}   config              Config. del país (longitud, checksum, etc.).
 * @param {Function} onChange            Setter genérico para los campos.
 * @param {Function} fetchPersonData     Función que llama al backend/padrón.
 * @param {Function} setIsFieldsDisabled Setter para bloquear/desbloquear campos.
 */
export async function handleNationalIdBlur(
  e,
  config,
  onChange,
  fetchPersonData,
  setIsFieldsDisabled
) {
  const value = e.target.value
  onChange(e) // Mantiene el two-way binding original

  if (!config) return           // Sin país configurado → sin validación

  const cleaned = value.replace(/\D/g, '')
  const isInvalid = isNationalIdInvalid(cleaned, config)

  if (!isInvalid) {
    // Documento válido: consulta padrón solo si el país lo requiere
    if (config.validateAgainstPadron === true) {
      await fetchPersonData(config?.code, cleaned, onChange, setIsFieldsDisabled)
    }
    // Si no requiere padrón simplemente se deja todo como está
  } else {
    // Documento inválido: limpia campos sensibles y desbloquea edición
    const fieldsToClear = [
      'nationalId',
      'passport',
      'firstName',
      'middleName',
      'lastName',
      'secondLastName',
      'gender',
      'birthdate'
    ]

    fieldsToClear.forEach(field =>
      onChange({ target: { name: field, value: '' } })
    )

    setIsFieldsDisabled(false)
  }
}

/**
 * Actualiza estado del campo de cédula y reinicia advertencias.
 * @param {Event} e - Evento change.
 * @param {Object} config - Configuración del país activo.
 * @param {Function} onChange - Setter de campos.
 * @param {Function} setNationalIdTouched - Setter para estado touched.
 * @param {Function} setWasChecksumInvalid - Setter para control de validez.
 */
export function handleNationalIdChange(
  e,
  config,
  onChange,
  setNationalIdTouched,
  setWasChecksumInvalid
) {
  const value = e.target.value
  onChange(e)

  const cleaned = value.replace(/\D/g, '')
  setNationalIdTouched(true)

  if (!config) return

  if (cleaned.length < config.nationalIdLength) {
    setWasChecksumInvalid(false)
  } else if (cleaned.length === config.nationalIdLength) {
    if (config.checksum && typeof isValidDominicanID === 'function') {
      setWasChecksumInvalid(!isValidDominicanID(cleaned))
    } else {
      setWasChecksumInvalid(false)
    }
  } else {
    setWasChecksumInvalid(true)
  }
}
